import styled from "styled-components";
import { media } from "../../../breakpoints";

export const Wrapper = styled.div`
  display: flex;

  ${media.tablet`
    flex-direction: column;
    gap: 30px;
  `}

  h3{
    font-size: 20px;
    font-weight: 300;
    color: #50637F;
    margin-bottom: 20px;
  }

  .profile-info{
    width: 50%;
    padding-right: 50px;
    border-right: 1px solid #E8E8E8;

    ${media.tablet`
      width: 100%;
      padding-right: 0;
      border-right: none;
      border-bottom: 1px solid #E8E8E8;
      padding-bottom: 30px;
    `}
  }

  .login-info{
    width: 50%;
    padding-left: 50px;

    ${media.tablet`
      width: 100%;
      padding-left: 0;
    `}
    
    .save{
      margin-top: 75px;
      display: flex;
      justify-content: right;

      ${media.tablet`
        margin-top: 30px;
      `}
    }
  }

  label{
    display: block;
    margin-top: 16px;
    margin-bottom: 9px;
    font-size: 12px;
    color: #506280;
  }
  
  
`